import { wrapString } from '@/modules/common/utils/string'

export const CAST_PROPERTY_BOX_MARKER: Readonly<string> = '%'
export const CAST_PROPERTY_BOX_NAMES_RAW: Readonly<string[]> = ['name', 'tag', 'flag', 'discipline', 'venue']
export const CAST_PROPERTY_BOX_NAMES: Readonly<string[]> = CAST_PROPERTY_BOX_NAMES_RAW.map((name) => {
  return wrapString(name, CAST_PROPERTY_BOX_MARKER)
})

export const LAYOUT_BASE_WIDTH = 1920
export const LAYOUT_BASE_HEIGHT = 1080

export const UNIT_PX = 'px'
